module.exports = "https://cdn.littlereply.com/tt/resource/icon_followers.3f1a6106b42912f89cbd7ccb57db596f.png";